module.exports = __webpack_public_path__ + "img/grouping-dude-with-suggestions.e73b431d.svg";